import React from 'react';
import { useStyletron } from 'baseui';
import { CustomColumn, StringColumn } from 'baseui/data-table';

import { CustomDateColumn, GLOBAL_THEME, EMPTY_STRING } from 'commons-ui';
import { EContentViewCardsType } from '../../utils/types';

const isLive = (liveSince: number, liveTill: number): boolean => {
	const currDate: number = Date.now();
	return liveSince < currDate && currDate < liveTill;
};

export const columnConfigs = [
	CustomColumn({
		title: 'Live Status',
		mapDataToValue: (data: any) => isLive(data.liveSince, data.liveTill),
		maxWidth: 100,
		renderCell: (params: any) => {
			const { value } = params;
			const text: string = value ? 'YES' : 'NO';
			const [css] = useStyletron();
			return (
				<div
					className={css({
						backgroundColor: value ? GLOBAL_THEME.Colors.lightgreen : GLOBAL_THEME.Colors.lightcoral,
						height: '30px',
						width: '100%',
						textAlign: 'center'
					})}>
					{text}
				</div>
			);
		}
	}),
	CustomColumn({
		title: 'Tag Visible',
		mapDataToValue: (data: any) => data?.tagInfo?.visible,
		maxWidth: 100,
		renderCell: (params: any) => {
			const { value } = params;
			const text: string = value ? 'YES' : 'NO';
			const [css] = useStyletron();
			return (
				<div
					className={css({
						backgroundColor: value ? GLOBAL_THEME.Colors.lightgreen : GLOBAL_THEME.Colors.lightcoral,
						height: '30px',
						width: '100%',
						textAlign: 'center'
					})}>
					{text}
				</div>
			);
		}
	}),
	StringColumn({
		title: 'View Count',
		maxWidth: 150,
		mapDataToValue: (data: any) => (data.viewCount.value ? String(data.viewCount.value) : EMPTY_STRING),
		columnName: 'viewCount'
	}),
	StringColumn({
		title: 'Name',
		width: 300,
		mapDataToValue: (data: any) => data.userData.displayName.en || EMPTY_STRING,
		columnName: 'name'
	}),
	StringColumn({
		title: 'Location',
		maxWidth: 300,
		mapDataToValue: (data: any) =>
			data.userStats.find((stat: { [key: string]: any }) => stat.type === EContentViewCardsType.LOCATION)?.value?.en ||
			EMPTY_STRING,
		columnName: 'location'
	}),
	StringColumn({
		title: 'Occupation',
		maxWidth: 300,
		mapDataToValue: (data: any) =>
			data.userStats.find((stat: { [key: string]: any }) => stat.type === EContentViewCardsType.OCCUPATION)?.value?.en ||
			EMPTY_STRING,
		columnName: 'occupation'
	}),
	StringColumn({
		title: 'Fav Game',
		maxWidth: 300,
		mapDataToValue: (data: any) =>
			data.userStats.find((stat: { [key: string]: any }) => stat.type === EContentViewCardsType.FAVORITE_GAME)?.value?.en ||
			EMPTY_STRING,
		columnName: 'favGame'
	}),
	StringColumn({
		title: 'Playing Since',
		maxWidth: 300,
		mapDataToValue: (data: any) =>
			data.userStats.find((stat: { [key: string]: any }) => stat.type === EContentViewCardsType.PLAYING_SINCE)?.value?.en ||
			EMPTY_STRING,
		columnName: 'playingSince'
	}),
	CustomColumn({
		title: 'Thumbnail',
		maxWidth: 100,
		minHeight: 500,
		mapDataToValue: (data: any) => data.data.thumbnailUrl,
		renderCell: ({ value }: { value: any }) => {
			const [css] = useStyletron();
			return (
				<a href={value} target='_blank' rel='noreferrer'>
					<img src={value} alt='' className={css({ height: '90px' })} />
				</a>
			);
		}
	}),
	CustomDateColumn({
		title: 'Created At',
		minWidth: 150,
		maxWidth: 200,
		columnName: 'createdAt'
	}),
	CustomDateColumn({
		title: 'Updated At',
		minWidth: 150,
		maxWidth: 200,
		columnName: 'updatedAt'
	}),
	CustomDateColumn({
		title: 'Live Till',
		minWidth: 150,
		maxWidth: 200,
		columnName: 'liveTill'
	})
];

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 1,
		pageSize: 10
	}
};
